import { apiClient } from './apiClient';

export const superAdminAPI = {
  // Get system overview
  getSystemOverview: async () => {
    const response = await apiClient.get('/super-admin/overview');
    return response.data;
  },

  // Get all users data
  getAllUsersData: async (filters = {}) => {
    const params = new URLSearchParams();
    
    Object.keys(filters).forEach(key => {
      if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
        params.append(key, filters[key]);
      }
    });

    const response = await apiClient.get(`/super-admin/users?${params.toString()}`);
    return response.data;
  },

  // Get all documents data
  getAllDocumentsData: async (filters = {}) => {
    const params = new URLSearchParams();
    
    Object.keys(filters).forEach(key => {
      if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
        params.append(key, filters[key]);
      }
    });

    const response = await apiClient.get(`/super-admin/documents?${params.toString()}`);
    return response.data;
  },

  // Get all task assignments data
  getAllTaskAssignmentsData: async (filters = {}) => {
    const params = new URLSearchParams();
    
    Object.keys(filters).forEach(key => {
      if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
        params.append(key, filters[key]);
      }
    });

    const response = await apiClient.get(`/super-admin/task-assignments?${params.toString()}`);
    return response.data;
  },

  // Get all audit logs data
  getAllAuditLogsData: async (filters = {}) => {
    const params = new URLSearchParams();
    
    Object.keys(filters).forEach(key => {
      if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
        params.append(key, filters[key]);
      }
    });

    const response = await apiClient.get(`/super-admin/audit-logs?${params.toString()}`);
    return response.data;
  },

  // Get complete document flow
  getDocumentFlow: async (documentId) => {
    const response = await apiClient.get(`/super-admin/document-flow/${documentId}`);
    return response.data;
  },

  // Get audit logs for specific entity
  getEntityAuditLogs: async (entityType, entityId, filters = {}) => {
    const params = new URLSearchParams();
    
    Object.keys(filters).forEach(key => {
      if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
        params.append(key, filters[key]);
      }
    });

    const response = await apiClient.get(`/super-admin/audit-logs/${entityType}/${entityId}?${params.toString()}`);
    return response.data;
  },

  // Get user activity details
  getUserActivityDetails: async (userId, filters = {}) => {
    const params = new URLSearchParams();
    
    Object.keys(filters).forEach(key => {
      if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
        params.append(key, filters[key]);
      }
    });

    const response = await apiClient.get(`/super-admin/users/${userId}/activity?${params.toString()}`);
    return response.data;
  },

  // Export system data
  exportSystemData: async (dataType, filters = {}) => {
    const params = new URLSearchParams();
    
    Object.keys(filters).forEach(key => {
      if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
        params.append(key, filters[key]);
      }
    });

    const response = await apiClient.get(`/super-admin/export/${dataType}?${params.toString()}`);
    return response.data;
  },

  // Get system health
  getSystemHealth: async () => {
    const response = await apiClient.get('/super-admin/health');
    return response.data;
  },

  // Get recent activities
  getRecentActivities: async (filters = {}, hours = 24) => {
    const params = new URLSearchParams();
    params.append('hours', hours);
    
    // Add filter parameters
    if (filters.userId) {
      params.append('userId', filters.userId);
    }
    if (filters.status) {
      params.append('status', filters.status);
    }
    
    const response = await apiClient.get(`/super-admin/recent-activities?${params.toString()}`);
    return response.data;
  },

  // Check super admin status
  checkSuperAdminStatus: async () => {
    const response = await apiClient.get('/super-admin/status');
    return response.data;
  },

  // Get system statistics
  getSystemStatistics: async () => {
    const response = await apiClient.get('/super-admin/statistics');
    return response.data;
  }
};

